import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../hooks/store';
import { propUpdatePasswordThunk, propVerifyForgotPasswordEmailThunk } from '../../redux/reducer/propSlice';
import { withErrorHandler } from '../../utils/utils';
import { EmailData, emailSchema, EmailValidationData, emailValidationSchema } from '../../validation/login';
import Button from '../button/Button';
import Input from '../input/Input';

enum Step {
  EMAIL = 'EMAIL',
  OTP_AND_PASSWORD = 'OTP_AND_PASSWORD'
}
const ForgetPassword: React.FC<{ from: string }> = ({ from }) => {
  const dispatch = useAppDispatch();
  const [step, setStep] = useState<Step>(Step.EMAIL);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<EmailData | EmailValidationData>({
    resolver: yupResolver(step === Step.EMAIL ? emailSchema : emailValidationSchema)
  });

  const commonProps = {
    register,
    errors,
    required: true,
    className: `bg-gray-200 h-[35px] rounded-md px-2 font-medium text-black`
  };

  const navigate = useNavigate();

  const onSubmit = async (data: EmailData | EmailValidationData) => {
    if (step === Step.EMAIL) {
      await withErrorHandler(async () => {
        await dispatch(propVerifyForgotPasswordEmailThunk({ email: data.email })).unwrap();
        setStep(Step.OTP_AND_PASSWORD);
      }, 'Send OTP to your email.');
    } else {
      await withErrorHandler(async () => {
        await dispatch(propUpdatePasswordThunk(data as EmailValidationData)).unwrap();
        reset();
        setStep(Step.EMAIL);
        navigate(from, { replace: true });
      }, 'Password updated successfully.');
    }
  };

  return (
    <div>
      <form className="flex flex-col mt-3" onSubmit={handleSubmit(onSubmit)}>
        <Input
          type="email"
          placeholder="Enter Your Email"
          name="email"
          readOnly={step === Step.OTP_AND_PASSWORD}
          {...commonProps}
        />

        {step === Step.OTP_AND_PASSWORD && (
          <>
            <Input type="text" placeholder="Enter OTP" name="otp" {...commonProps} />
            <Input type="password" placeholder="Enter Your New Password" name="password" {...commonProps} />
            <Input
              type="password"
              placeholder="Confirm Your Password"
              name="confirmPassword"
              {...commonProps}
            />
          </>
        )}

        <Button
          type="submit"
          className="bg-[#35e0a1] mt-6 h-[35px] rounded-md font-medium"
          label={step === Step.EMAIL ? 'Send OTP' : 'Reset Password'}
        />
      </form>
    </div>
  );
};

export default ForgetPassword;
